var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isButton
    ? _c(
        "button",
        {
          ref: "buttonElement",
          class: _vm.classes,
          attrs: {
            type: _vm.type,
            disabled: _vm.isDisabledInternal,
            "data-ob1-component": _vm.dataOb1Component,
            "data-oevent-category": _vm.actionTms.category,
            "data-oevent-action": _vm.actionTms.action,
            "data-oevent-label": _vm.actionTms.label,
            "data-timer": _vm.timer,
            title: _vm.title,
          },
          on: { click: _vm.onClick },
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n")]
      )
    : _c(
        "a",
        {
          ref: "buttonElement",
          class: _vm.classes,
          attrs: {
            href: _vm.href,
            "aria-disabled": _vm.isDisabledInternal ? "true" : null,
            "data-oevent-category": _vm.actionTms.category,
            "data-oevent-action": _vm.actionTms.action,
            "data-oevent-label": _vm.actionTms.label,
            title: _vm.title,
          },
          on: { click: _vm.onClick },
        },
        [_vm._v(_vm._s(_vm.label))]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }